import './boxsizes.scss';

(function() {
  const triggers = document.querySelectorAll('.box-size__booking-trigger-wrapper');
  const bodies = document.querySelectorAll('.box-size__booking');
  const infoTriggers = document.querySelectorAll('.box-size__info-trigger');
  const infoBoxes = document.querySelectorAll('.box-size__infobox');
  const imageWrappers = document.querySelectorAll('.box-size__image-wrapper');
  let openBodies = [];
  let openBoxes = [];

  triggers.forEach((trigger, id) => {
    trigger.addEventListener('click', event => {
      event.preventDefault();

      trigger.classList.toggle('open');

      if (openBodies.includes(id)) {
        bodies[id].style.maxHeight = 0;
        openBodies = openBodies.filter(item => item !== id);
      }
      else {
        bodies[id].style.maxHeight = bodies[id].scrollHeight + 'px';
        openBodies.push(id);
      }
    });
  });

  infoTriggers.forEach((trigger, id) => {
    trigger.addEventListener('click', event => {
      event.preventDefault();

      trigger.classList.toggle('active');

      if (openBoxes.includes(id)) {
        infoBoxes[id].style.maxHeight = 0;
        openBoxes = openBoxes.filter(item => item !== id);
        imageWrappers[id].classList.remove('infobox-open');
        trigger.innerHTML = 'i';
      }
      else {
        infoBoxes[id].style.maxHeight = infoBoxes[id].scrollHeight + 'px';
        openBoxes.push(id);
        imageWrappers[id].classList.add('infobox-open');
        trigger.innerHTML = 'X';
      }
    });
  });
})();
